<div class="content-header">
  <div>
    <h1>Upgrade Management</h1>
  </div>
  <div>
    @if (authStore.canEdit()) {
      <sdc-button
        variant="primary"
        [attr.data-cy]="'upgrade-create-button'"
        (onClick)="openModalCreate()">
        Create New Upgrade
      </sdc-button>
    }
  </div>
</div>

<gs-table [data]="data" [columns]="columns" [loading]="loading()"></gs-table>

<p class="legend">
  Showing {{ data.length }} of {{ totalItemsInDb }} total Upgrade
</p>
<app-pagination
  [currentPage]="currentPage"
  [totalItemsInDb]="totalItemsInDb"
  [itemsPerPage]="itemsPerPage"
  #pagination></app-pagination>
